import { useIntersectionObserver } from 'app/modules/ui/hooks/useIntersectionObserver';
import React, { useEffect } from 'react';

type ItemProps<T> = {
  renderItem: () => React.ReactNode;
  animation?: 'fade' | 'slide';
  item: T;
  index: number;
  height?: number;
};

const Item = <T,>(props: ItemProps<T>) => {
  const [visible, setVisible] = React.useState(false);
  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: '0px'
  });

  useEffect(() => {
    if (entry?.isIntersecting && !visible) {
      setVisible(true);
    }
  }, [entry, visible]);

  return (
    <div style={{ minHeight: props.height }} ref={ref}>
      {visible && props.renderItem()}
    </div>
  );
};

export default Item;
